<template>
<ItpFormSelect2
  :name="path"
  v-model="item[path]"
  :options="options"
  prefetch
  valueField="id"
  textField="description"
  :bindObject="bindObject"
  :clearable="clearable"
  :autofocus="autofocus"
  :disabled="disabled || readonly || item.isReadonly"
  :readonly="readonly || item.isReadonly"
  :required="required"
  v-if="item"
  @input="evh_7315092382398562_input($event, {})"
>
</ItpFormSelect2>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcMailAccountSelector extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    required: true,
    type: String,
  })
  path!: string;

  @Watch('path')
  onPath(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("path")
  }

  @Prop({
    type: Boolean,
  })
  required!: boolean;

  @Watch('required')
  onRequired(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("required")
  }

  @Prop({
    type: Boolean,
  })
  readonly!: boolean;

  @Watch('readonly')
  onReadonly(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("readonly")
  }

  @Prop({
    type: Boolean,
  })
  disabled!: boolean;

  @Watch('disabled')
  onDisabled(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("disabled")
  }

  @Prop({
    type: Boolean,
  })
  autofocus!: boolean;

  @Watch('autofocus')
  onAutofocus(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("autofocus")
  }

  @Prop({
    type: Boolean,
  })
  clearable!: boolean;

  @Watch('clearable')
  onClearable(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("clearable")
  }

  @Prop({
    type: Boolean,
  })
  bindObject!: boolean;

  @Watch('bindObject')
  onBind_object(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("bindObject")
  }

  options!: any;

  async $$load_options() {
    return this.$app.repo.get('list_object_by_type', { parameters: { object_type: 'mail-account' } })
  }

  ux!: any;
  dataMembers = ['options', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        options: null,
        ux: null,
      },
    }
  }

  async act_7315092382398562_script_4770_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_7315092382398562_script_4770, alias=undefined
    this.$emit('input')
  }

  async act_7315092382398562_script_4770_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_7315092382398562_script_4770, alias=undefined
    return {
      value: () => this.act_7315092382398562_script_4770_getActionArgs_value($event),
    }
  }

  async evh_7315092382398562_input(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_input.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_script_4770: actions.ScriptAction;
    evh_7315092382398562_input_4769: actions.EventHandlerImpl;
    evh_7315092382398562_input: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_script_4770 = new actions.ScriptAction(
      {
        actionArgs: this.act_7315092382398562_script_4770_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_input_4769 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_script_4770,
        event: "input",
        displayName: "script",
      }
    );
    const evh_7315092382398562_input = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_input_4769],
      }
    );
    return {
      act_7315092382398562_script_4770,
      evh_7315092382398562_input_4769,
      evh_7315092382398562_input,
    }
  }
}

Vue.component("UcMailAccountSelector", UcMailAccountSelector);

</script>